import { render } from "./UserListHeader.vue?vue&type=template&id=f5b90766"
import script from "./UserListHeader.vue?vue&type=script&lang=js"
export * from "./UserListHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__